export default "__VITE_ASSET__DZLULLlQ__"